import { render } from "./PopupCustom.vue?vue&type=template&id=b1041a5c&scoped=true"
import script from "./PopupCustom.vue?vue&type=script&lang=js"
export * from "./PopupCustom.vue?vue&type=script&lang=js"

import "./PopupCustom.vue?vue&type=style&index=0&id=b1041a5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1041a5c"]])

export default __exports__